import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Toggle.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { attrs: { for: _vm.id, disabled: _vm.disabled } }, [
    _c("input", {
      attrs: {
        id: _vm.id,
        disabled: _vm.disabled,
        type: "checkbox",
        appearance: _vm.appearance
      },
      domProps: { checked: _vm.value },
      on: { change: _vm.toggle }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "slide", attrs: { size: _vm.size } }, [
      _c(
        "div",
        { staticClass: "slide-inner" },
        [
          _vm.value
            ? _c("EditorDoneIcon", {
                staticClass: "done",
                attrs: {
                  "data-cy": "done",
                  size: _vm.iconSize,
                  "primary-color": _vm.color
                }
              })
            : _c("EditorCloseIcon", {
                staticClass: "close",
                attrs: {
                  "data-cy": "cross",
                  size: _vm.iconSize,
                  "primary-color": _vm.color
                }
              })
        ],
        1
      )
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-2748fbe4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Toggle/Toggle.vue.js